export interface NotificationState {
  messages: NotificationMessage[];
}

export interface NotificationElementOptions {
  elementIdentifier: string;
  func: any;
}

export interface NotificationMessage {
  message: string;
  type: 'Success' | 'Failure';
  element?: NotificationElementOptions;
}

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_TOP_NOTIFICATION = 'REMOVE_TOP_NOTIFICATION';

export interface AddNotificationAction {
  type: typeof ADD_NOTIFICATION;
  payload: NotificationMessage;
}

export interface RemoveTopNotificationAction {
  type: typeof REMOVE_TOP_NOTIFICATION;
}
export type NotificationActionTypes = AddNotificationAction | RemoveTopNotificationAction;
